const getCurrencyDisplayIcon = (
  currency?: CashierCurrency,
  isUbtcEnabled = false,
) => {
  if (currency === "BTC") {
    return getIcon(isUbtcEnabled ? "uBTC" : "mBTC");
  }
  return getIcon(currency);
};

const getIcon = (currency?: CashierCurrency | BtcUnit | "satoshi") => {
  switch (currency) {
    case "satoshi":
      return "BTC";
    case "uBTC":
      return "µBTC";
    case undefined:
    case null:
      return "";
    default:
      return currency;
  }
};

export default getCurrencyDisplayIcon;
